import {
  API_REQUEST_START,
  API_REQUEST_END,
  API_REQUEST_CANCELLED,
} from 'actionTypes';

export function signalApiRequestStart(apiAction) {
  return {
    type: API_REQUEST_START,
    apiAction,
  };
}

export function signalApiRequestEnd(apiAction, response) {
  // Response looks like:
  // {
  //   status: 200,
  //   payload: { ... }
  //   errors: {}
  // }
  return {
    ...response,
    type: API_REQUEST_END,
    apiAction,
  };
}

export function signalApiRequestCancelled(apiAction) {
  return {
    type: API_REQUEST_CANCELLED,
    apiAction,
  };
}



// WEBPACK FOOTER //
// ./src/actions/apiActions.js